import { ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout/models';

import { useHeaderNavigation } from '../../components';
import { getComponentProps } from '../../getters';

export const useComponentProps = (componentName: string): ComponentRendering | null => {
  const { route } = useHeaderNavigation();

  return (route && getComponentProps(route.placeholders, componentName)) || null;
};
